import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppLayout from '../components/AppLayout';
import Modal from '../components/Modal';
import { useApi } from '../hooks/useApi';
const UsersPage = () => {
    const { get, post, put, del } = useApi();
    const [users, setUsers] = useState([]);
    const [message, setMessage] = useState(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [createForm, setCreateForm] = useState({ username: '', password: '' });
    const [editForm, setEditForm] = useState({ username: '', password: '' });
    const [editingUser, setEditingUser] = useState(null);
    const loadUsers = async () => {
        const data = await get('/users');
        setUsers(data);
    };
    useEffect(() => {
        loadUsers();
    }, []);
    const handleCreate = async (event) => {
        event.preventDefault();
        try {
            await post('/users', createForm);
            setCreateForm({ username: '', password: '' });
            setMessage('User created');
            setCreateModalOpen(false);
            loadUsers();
        }
        catch (error) {
            setMessage(error.message);
        }
    };
    const handleEdit = async (event) => {
        event.preventDefault();
        if (!editingUser)
            return;
        try {
            await put(`/users/${editingUser.id}`, {
                username: editForm.username,
                password: editForm.password || undefined
            });
            setMessage('User updated');
            setEditModalOpen(false);
            setEditingUser(null);
            setEditForm({ username: '', password: '' });
            loadUsers();
        }
        catch (error) {
            setMessage(error.message);
        }
    };
    const handleDelete = async (user) => {
        if (!window.confirm(`Remove user ${user.username}?`)) {
            return;
        }
        try {
            await del(`/users/${user.id}`);
            setMessage('User removed');
            loadUsers();
        }
        catch (error) {
            setMessage(error.message);
        }
    };
    const openEditModal = (user) => {
        setEditingUser(user);
        setEditForm({ username: user.username, password: '' });
        setEditModalOpen(true);
    };
    return (_jsxs(AppLayout, { title: "Users", actions: _jsx("button", { onClick: () => setCreateModalOpen(true), children: "New user" }), children: [_jsxs("div", { className: "card", children: [_jsx("h3", { style: { marginTop: 0 }, children: "Accounts" }), _jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Username" }), _jsx("th", { children: "Must change password" }), _jsx("th", { children: "Actions" })] }) }), _jsxs("tbody", { children: [users.map((user) => (_jsxs("tr", { children: [_jsx("td", { children: user.username }), _jsx("td", { children: user.mustChangePassword ? 'Yes' : 'No' }), _jsxs("td", { children: [_jsx("button", { style: { marginRight: '0.5rem' }, onClick: () => openEditModal(user), children: "Edit" }), _jsx("button", { style: { background: 'tomato', color: '#000' }, onClick: () => handleDelete(user), children: "Remove" })] })] }, user.id))), !users.length && (_jsx("tr", { children: _jsx("td", { colSpan: 3, style: { textAlign: 'center', padding: '1rem' }, children: "No users found." }) }))] })] })] }), message && (_jsx("div", { className: "card", style: { color: 'rgb(73, 181, 116)' }, children: message })), _jsx(Modal, { open: createModalOpen, title: "Create user", onClose: () => setCreateModalOpen(false), children: _jsxs("form", { onSubmit: handleCreate, className: "content-grid", style: { gap: '1rem' }, children: [_jsxs("div", { children: [_jsx("label", { children: "Username" }), _jsx("input", { value: createForm.username, onChange: (event) => setCreateForm((prev) => ({
                                        ...prev,
                                        username: event.target.value
                                    })), required: true })] }), _jsxs("div", { children: [_jsx("label", { children: "Password" }), _jsx("input", { type: "password", value: createForm.password, onChange: (event) => setCreateForm((prev) => ({
                                        ...prev,
                                        password: event.target.value
                                    })), required: true })] }), _jsx("div", { style: { textAlign: 'right' }, children: _jsx("button", { type: "submit", children: "Create" }) })] }) }), _jsx(Modal, { open: editModalOpen, title: editingUser ? `Edit ${editingUser.username}` : 'Edit user', onClose: () => {
                    setEditModalOpen(false);
                    setEditingUser(null);
                }, children: _jsxs("form", { onSubmit: handleEdit, className: "content-grid", style: { gap: '1rem' }, children: [_jsxs("div", { children: [_jsx("label", { children: "Username" }), _jsx("input", { value: editForm.username, onChange: (event) => setEditForm((prev) => ({
                                        ...prev,
                                        username: event.target.value
                                    })), required: true })] }), _jsxs("div", { children: [_jsx("label", { children: "New password (optional)" }), _jsx("input", { type: "password", value: editForm.password, onChange: (event) => setEditForm((prev) => ({
                                        ...prev,
                                        password: event.target.value
                                    })) })] }), _jsxs("div", { style: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }, children: [_jsx("button", { type: "button", style: {
                                        background: 'transparent',
                                        border: '1px solid var(--color-border)',
                                        color: 'var(--color-text)'
                                    }, onClick: () => {
                                        setEditModalOpen(false);
                                        setEditingUser(null);
                                    }, children: "Cancel" }), _jsx("button", { type: "submit", children: "Save" })] })] }) })] }));
};
export default UsersPage;
